import styled from 'styled-components';
import realtimeFonts from '../../../../fonts';
import {mobileMedia, scrollbar} from '../../../../../../globalVariables/GlobalVariables';
import {dFlex, dFlexColumn, dFlexBetween} from '../../../../../../globalVariables/GlobalFlex';
import {getSpacing} from '@tickchak/react-share/app';

export const container = styled.div`
    ${dFlexColumn}
    padding: var(--dimension-4-5);
    height: 390px;
    ${mobileMedia}{
        padding: 0;
        padding-block: var(--dimension-4-5);
        padding-inline: ${getSpacing('spaceXxs')};
        height: 100%;
    }
`;

export const title = styled.div`
    ${realtimeFonts.windowTitle}
    ${dFlexBetween}
    position: relative;
    width: calc(100% - 50px);
    margin-bottom: ${getSpacing('spaceMd')};
    ${mobileMedia}{
        padding-inline-start: ${getSpacing('spaceLg')};
        margin-bottom: 0;
    }
`;

export const content = styled.div`
    ${dFlex}
    flex: 1;
    min-height: 0;
    overflow: hidden;
    ${mobileMedia}{
        flex-direction: column;
    }
`;

export const tableSection = styled.div`
    ${dFlexColumn}
    flex: 1;
    min-width: 0;
    min-height: 0;
    height: 100%;
    overflow: hidden;
`;

export const tableContent = styled.div`
    ${scrollbar}
    flex: 1;
    min-height: 0;
    height: 100%;
    overflow: auto;
    ${mobileMedia}{
        max-height: 400px;
        padding-inline: ${getSpacing('spaceLg')};
    }
`;
